import moment from 'moment';

const actionsFlow = [{
  action: 'submit',
  status: 'submitted'
}, {
  action: 'acknowledge',
  status: 'acknowledged'
}, {
  action: 'approve_one',
  status: 'approved_one'
}, {
  action: 'approve_two',
  status: 'approved_two'
}, {
  action: 'approve_three',
  status: 'approved_three'
}, {
  action: 'approve_four',
  status: 'approved_four'
}, {
  action: 'approve_five',
  status: 'approved_five'
}];

const isNextSignAvailable = (status, nextSign, signFlow) => {
  let currentSignIndex = actionsFlow.findIndex(af => af.status === status);
  let nextSignIndex = actionsFlow.findIndex(af => af.action === nextSign && signFlow[nextSign] && signFlow[nextSign].required);

  if(currentSignIndex >= nextSignIndex) {
    return false;
  }

  if(currentSignIndex + 1 === nextSignIndex) {
    return true;
  } else {
    let hasRequiredAction = false;
    for(let i = currentSignIndex + 1; i < nextSignIndex; i++) {
      if(signFlow[actionsFlow[i].action] && signFlow[actionsFlow[i].action].required || actionsFlow[i].action ==='submit') {
        hasRequiredAction = true;
      }
    }

    //console.log('has required action', currentSignIndex, nextSignIndex, status, signFlow)
    return !hasRequiredAction;
  }
}

const hasScheduledAction = (reportJson) => {
  const { attributes } = reportJson;
  const signFlow = attributes.signFlow[reportJson.type];
  const authorGuid = attributes.author && attributes.author.authorGuid

  const getCanSendDorReminder = (scope, status) => {
    switch (status) {
      case 'submitted':
        return ['cstaff', 'fto', 'ftoc', 'sup', 'chief'].includes(scope);
      default:
        return false;
    }
  };
  const getCanSendEopReminder = (scope, status) => {
    switch (status) {
      case 'submitted':
        return ['cstaff', 'fto', 'ftoc', 'sup', 'chief'].includes(scope);
      case 'acknowledged':
        return ['cstaff', 'chief'].includes(scope);
      case 'approved_one':
        return ['ftoc', 'sup'].includes(scope);
      default:
        return false;
    }
  };
  const getCanSendWorReminder = (scope, status) => {
    switch (status) {
      case 'submitted':
        return ['cstaff', 'chief', 'fto', 'ftoc', 'sup'].includes(scope);
      case 'acknowledged':
        return ['cstaff', 'chief'].includes(scope);
      default:
        return false;
    }
  };
  return {
    getHasScheduledAction() {
      return !!attributes.schedule;
    },
    getCanSubmit(scope) {
      return signFlow.submit && signFlow.submit.roles.includes(scope);
    },
    getCanAcknowledge(scope) {
      return signFlow.acknowledge
        && signFlow.acknowledge.required
        && isNextSignAvailable(attributes.status, 'acknowledge', signFlow)
        && signFlow.acknowledge.roles
        && signFlow.acknowledge.roles.includes(scope);
    },
    getCanApprove(scope) {
      return signFlow.approve_one
        && signFlow.approve_one.required
        && signFlow.approve_one.roles
        && signFlow.approve_one.roles.includes(scope)
        && isNextSignAvailable(attributes.status, 'approve_one', signFlow);
    },
    getCanApproveTwo(scope) {
      return signFlow.approve_two
        && signFlow.approve_two.required
        && isNextSignAvailable(attributes.status, 'approve_two', signFlow)
        && signFlow.approve_two.roles
        && signFlow.approve_two.roles.includes(scope);
    },
    getCanApproveThree(scope) {
      return signFlow.approve_three
        && signFlow.approve_three.required
        && isNextSignAvailable(attributes.status, 'approve_three', signFlow)
        && signFlow.approve_three.roles
        && signFlow.approve_three.roles.includes(scope);
    },
    getCanApproveFour(scope) {
      return signFlow.approve_four
        && signFlow.approve_four.required
        && isNextSignAvailable(attributes.status, 'approve_four', signFlow)
        && signFlow.approve_four.roles
        && signFlow.approve_four.roles.includes(scope);
    },
    getCanApproveFive(scope) {
      return signFlow.approve_five
        && signFlow.approve_five.required
        && isNextSignAvailable(attributes.status, 'approve_five', signFlow)
        && signFlow.approve_five.roles
        && signFlow.approve_five.roles.includes(scope);
    },
    getCanSendReminder(scope) {
      const needsReminder = this.getIsLate() && !attributes.reminder;
      switch (reportJson.type) {
        case 'dor':
          return getCanSendDorReminder(scope, attributes.status) && this.getIsLateAck();
        case 'eop':
          return getCanSendEopReminder(scope, attributes.status) && this.getIsLateAck();
        case 'wor':
          return getCanSendWorReminder(scope, attributes.status) && this.getIsLateAck();
        default:
          return needsReminder;
      }
    },
    getIsAckDueNow() {
      return signFlow.acknowledge
        && signFlow.acknowledge.required
        && attributes.status === 'submitted'
        && this.getIsDueNow();
    },
    getIsAckDueFuture() {
      return signFlow.acknowledge
        && signFlow.acknowledge.required
        && attributes.status === 'submitted'
        && this.getIsDueInFuture();
    },
    getIsAckDueToday() {
      return signFlow.acknowledge
        && signFlow.acknowledge.required
        && attributes.status === 'submitted'
        && this.getIsDueToday();
    },
    getIsApprovalDueNow() {
      return isNextSignAvailable(attributes.status, 'approve_one', signFlow)
        && this.getIsDueNow();
    },
    getIsApprovalDueFuture() {
      return isNextSignAvailable(attributes.status, 'approve_one', signFlow)
        && this.getIsDueInFuture();
    },
    getIsCompleted() {
      if (attributes.status === 'completed') {
        return true
      }
      let currStatusIndex = actionsFlow.findIndex(af => af.status === attributes.status);
      for (let i = currStatusIndex + 1; i < actionsFlow.length; i++) {
        if (signFlow[actionsFlow[i].action] && signFlow[actionsFlow[i].action].required) {
          return false
        }
      }
      return true;
    },
    getIsDueNow() {
      const due = moment(attributes.actionAt);
      const late = moment(attributes.actionAt).add(24, 'hours');
      return moment().isSameOrAfter(due) && moment().isBefore(late);
    },
    getIsDueInFuture() {
      const due = moment(attributes.actionAt);
      return moment().isBefore(due)
    },
    getIsDueOrLate() {
      return this.getIsLate() || this.getIsDueNow() || this.getIsDueToday();
    },
    getIsDueToday() {
      const due = moment(attributes.actionAt);
      const oneDayAgo = moment(attributes.actionAt).subtract(24, 'hours');
      return moment().isAfter(oneDayAgo) && moment().isSameOrBefore(due);
    },
    getIsLate() {
      const late = moment(attributes.actionAt).add(24, 'hours');
      return moment().isSameOrAfter(late);
    },
    getIsLateAck() {
      return isNextSignAvailable(attributes.status, 'acknowledge', signFlow)
        && this.getIsLate();
    },
    getIsLateApproval() {
      return isNextSignAvailable(attributes.status, 'approve_one', signFlow)
        && this.getIsLate();
    },
    getIsSubmitted() {
      return reportJson.attributes.status !== 'draft'
        && reportJson.attributes.status !== 'cancelled'
        && reportJson.attributes.status !== 'scheduled'
        && reportJson.attributes.status !== 'rejected';
    },
    getIsApproveTwoDueNow() {
      return isNextSignAvailable(attributes.status, 'approve_two', signFlow)
        && this.getIsDueNow();
    },
    getIsApproveTwoDueInFuture() {
      return isNextSignAvailable(attributes.status, 'approve_two', signFlow)
        && this.getIsDueInFuture();
    },
    getIsApproveTwoIsLate() {
      return isNextSignAvailable(attributes.status, 'approve_two', signFlow)
        && this.getIsLate();
    },
    getIsApproveThreeDueNow() {
      return isNextSignAvailable(attributes.status, 'approve_three', signFlow)
        && this.getIsDueNow();
    },
    getIsApproveThreeDueInFuture() {
      return isNextSignAvailable(attributes.status, 'approve_three', signFlow)
        && this.getIsDueInFuture();
    },
    getIsApproveThreeIsLate() {
      return isNextSignAvailable(attributes.status, 'approve_three', signFlow)
        && this.getIsLate();
    },
    getIsApproveFourDueNow() {
      return isNextSignAvailable(attributes.status, 'approve_four', signFlow)
        && this.getIsDueNow();
    },
    getIsApproveFiveDueNow() {
      return isNextSignAvailable(attributes.status, 'approve_five', signFlow)
        && this.getIsDueNow();
    },
    getIsApproveFourDueInFuture() {
      return isNextSignAvailable(attributes.status, 'approve_four', signFlow)
        && this.getIsDueInFuture();
    },
    getIsApproveFiveDueInFuture() {
      return isNextSignAvailable(attributes.status, 'approve_five', signFlow)
        && this.getIsDueInFuture();
    },
    getIsApproveFourIsLate() {
      return isNextSignAvailable(attributes.status, 'approve_four', signFlow)
        && this.getIsLate();
    },
    getIsApproveFiveIsLate() {
      return isNextSignAvailable(attributes.status, 'approve_five', signFlow)
        && this.getIsLate();
    },
    isNextSignAvailable(nextSign) {
      return isNextSignAvailable(attributes.status, nextSign, signFlow)
    },
    getTypeHasAcknowledgement() {
      return signFlow.acknowledge && signFlow.acknowledge.required
    },
    getTypeHasApproval() {
      return signFlow.approve_one && signFlow.approve_one.required
    },
    getTypeHasApproveTwo() {
      return signFlow.approve_two && signFlow.approve_two.required
    },
    getTypeHasApproveThree() {
      return signFlow.approve_three && signFlow.approve_three.required
    },
    getTypeHasApproveFour() {
      return signFlow.approve_four && signFlow.approve_four.required
    },
    getTypeHasApproveFive() {
      return signFlow.approve_five && signFlow.approve_five.required
    },
    getIsSubmitterOit() {
      return signFlow.submit && signFlow.submit.roles.includes('oit');
    },
    getIsUserAuthor(userGuid) {
      if (!authorGuid) {
        return true
      }
      return authorGuid === userGuid;
    }
  };
};

export default hasScheduledAction;
